import { useEffect } from 'react';
import { useLocation } from 'react-router';

export function ScrollToTop() {
    const { pathname } = useLocation();

    // biome-ignore lint/correctness/useExhaustiveDependencies: this diagnostic is incorrect
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
